module.exports = "<p>\n  teams works!\n  {{ team }}\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/teams/teams.component.html
// module id = ./src/app/teams/teams.component.html
// module chunks = main